import { VStack } from '@montel/montelpro-shared-components-v2';
import { css, styled } from 'styled-components';

//TODO: use theme.colors.bgRowSubGroup for alternate row background color after upgrading shared components
export const StyledTable = styled.table<{ $alternateRowBackground: boolean }>`
	width: 100%;
	border-collapse: collapse;
	${({ $alternateRowBackground }) => css`
		${$alternateRowBackground &&
		css`
			tr.even {
				background-color: #ffffff0d;
			}
			tr:hover + tr.expanded-content {
				background-color: ${({ theme }) =>
					theme.colors.bgHover} !important;
			}
			tr.even + tr.expanded-content {
				background-color: #ffffff0d;
			}
			tr:has(+ .expanded-content:hover) {
				background-color: ${({ theme }) =>
					theme.colors.bgHover} !important;
			}
		`}
	`}
`;

export const Container = styled(VStack)`
	display: flex;
	max-width: 100%;
	overflow-x: auto;
`;

export const TableWrapper = styled.div`
	${({ theme }) => css`
		width: 100%;
		background-color: ${theme.colors.bgMainContainer};
		border-radius: ${theme.borderRadii.lg};
		padding: ${theme.spacing.md} 0;
	`};
`;

export const ScrollWrapper = styled.div`
	${({ theme }) => css`
		overflow-x: auto;
		padding-bottom: ${theme.spacing.md};
	`};
`;

export const StyledTableRow = styled.tr<{
	$clickable?: boolean;
	$selected?: boolean;
	$faded?: boolean;
}>`
	${({ $clickable }) => $clickable && `cursor: pointer;`}
	${({ $faded }) => $faded && `opacity: 0.5;`}
	${({ $selected, theme }) =>
		$selected && `background-color: ${theme.colors.bgSelected} !important;`}
	&:hover {
		background-color: ${({ theme }) => theme.colors.bgHover} !important;
	}
`;

export const StyledHeadRow = styled.tr`
	text-align: left;
	vertical-align: middle;
	${({ theme }) => `
		padding-bottom: ${theme.spacing.sm};
		height: ${theme.spacing.xl};
	`};
`;
